import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { fetchUserVotes } from '../actions/fetchUserVotes';
import { userVotesAtom, userVotesLoadingAtom } from '../atoms/userData';
import { Address } from 'viem';

export const useFetchVoterVotes = (voterId: Address) => {
  const setVoterVotes = useSetAtom(userVotesAtom);
  const setVoterVotesLoading = useSetAtom(userVotesLoadingAtom);

  const mutation = useMutation({
    mutationFn: async () => {
      const { votes } = await fetchUserVotes(voterId);
      setVoterVotes(votes);
      setVoterVotesLoading(false);
    },
    onError: (error) => {
      console.error('Error fetching user votes:', error);
      setVoterVotesLoading(false);
    },
  });

  useEffect(() => {
    mutation.mutate();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [voterId]);

  return { mutation };
};
